/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { css, jsx } from '@emotion/react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useContext } from 'react'

import { EuiButton, useEuiTheme } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { outlineButtonStyle } from '@modules/access-management-components/styles'
import { ssoLoginUrl } from '@modules/auth/urls'
import AuthContext from '@modules/auth/context'

import { buildSignInLink, buildSignInQuery } from '@/lib/urlUtils'

const SsoSignUp = ({ ssoLoginIdentifier }: { ssoLoginIdentifier?: string }) => {
  const euiThemeHook = useEuiTheme()
  const { setAuthMethod } = useContext(AuthContext)
  const navigate = useNavigate()

  const { search, pathname } = useLocation()
  const ssoLink = buildSignInLink(
    ssoLoginIdentifier ? `${ssoLoginUrl()}/${ssoLoginIdentifier}` : ssoLoginUrl(),
    buildSignInQuery({ search, withReferrer: false }),
  )

  return (
    <EuiButton
      iconType='key'
      css={css(
        {
          path: {
            fill: 'grey',
          },
        },
        outlineButtonStyle(euiThemeHook),
      )}
      color='primary'
      onClick={(e) => {
        e.preventDefault()
        setAuthMethod('byoidp')
        navigate(ssoLink, { state: { from: pathname } })
      }}
    >
      <FormattedMessage id='login-form.sso' defaultMessage='SSO' />
    </EuiButton>
  )
}

export default SsoSignUp
